import { render } from "./SelectMeta.vue?vue&type=template&id=a285d270&scoped=true"
import script from "./SelectMeta.vue?vue&type=script&lang=js"
export * from "./SelectMeta.vue?vue&type=script&lang=js"

import "./SelectMeta.vue?vue&type=style&index=0&id=a285d270&lang=scss&scoped=true"

import exportComponent from "/Users/pmattern/Documents/3 - GIT/studio-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a285d270"]])

export default __exports__